import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { UserService } from 'src/app/_services/user/user.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';

@Component({
  selector: 'app-myproject-v2',
  templateUrl: './myproject-v2.component.html',
  styleUrls: ['./myproject-v2.component.scss']
})
export class MyprojectV2Component implements OnInit {
  tenantId: string;
  projectv2Form;
  // / row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  currentUser: any;
  selectedFile: File;
  jsonData: any;
  users: any;
  userDetails: any;
  gridApi: any;
  gridColumnApi: any;
  form: FormGroup;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  projectId: any;
  isAdministrator: boolean = false;
  isPMOAdmin: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private projectService: ProjectService,  
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private storageService: LocalStorageService,
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.projectv2Form = new FormGroup({
      projectName: new FormControl(''),
      projectCode: new FormControl(''),
      projectDescription: new FormControl(''),
      projectManagerId: new FormControl(''),
      projectManagerName: new FormControl(''),
      projectLeadId: new FormControl(''),
      projectLeadName: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      decisionDate: new FormControl(''),
      customer: new FormControl(''),
      status: new FormControl(''),
      createdByUserId: new FormControl(''),
      createdByUserName: new FormControl(''),
      totalHours: new FormControl(''),
      remainingHours: new FormControl(''),
      percentageCompleted: new FormControl(''),
      regionId: new FormControl(''),
      regionName: new FormControl(''),
      industryId: new FormControl(''),
      industryName: new FormControl(''),
      businessGroupId: new FormControl(''),
      businessGroupName: new FormControl(''),
      commodityId: new FormControl(''),
      commodityName: new FormControl(''),
      activityId: new FormControl(''),
      activityName: new FormControl(''),
      projectSoftwareId: new FormControl(''),
      projectSoftwareName: new FormControl(''),
      parentProjectId: new FormControl(''),

    })
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.userDetails.roles.includes('RolePmoAdministrator');
    this.getUsers();
    this.getProjectsV2Data();
  }

  getProjectsV2Data() {
    if(this.isAdministrator || this.isPMOAdmin){
      this.projectService.getAllRootProjectV2().subscribe((response: any) => {
          this.rowData = response;
        });
    } else{
      this.projectService.getAllProjectV2ByUserId(this.userDetails.id).subscribe((response: any) => {
        this.rowData = response;
      });
    }
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: "Project Name",
        field: "projectName",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: "Project Code",
        field: "projectCode",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Manager ",
        field: "projectManagerName",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Start Date",
        field: "startDate",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "End Date",
        field: "endDate",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Description",
        field: "projectDescription",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Project LeadName",
        field: "projectLeadName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Customer",
        field: "customer",
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: "Status",
        field: "status",
        cellStyle: (params) => {
         if (params.value === 'On hold' || params.value === 'On hold') {
            return { color: 'orange', 'font-weight': 'bold' };
          } else if (params.value === 'Active' || params.value === 'Active') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Archive' || params.value === 'Archive') {
            return { color: 'red', 'font-weight': 'bold' };
          } 
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
      }, 
      {
        headerName: "Decision Date",
        field: "decisionDate",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "createdBy UserName",
        field: "createdByUserName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Total Hours ",
        field: "totalHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Remaining Hours",
        field: "remainingHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Region Name",
        field: "regionName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Industry Name",
        field: "industryName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Business GroupName",
        field: "businessGroupName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Commodity Name",
        field: "commodityName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Activity Name",
        field: "activityName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "projectSoftwareName",
        field: "projectSoftwareName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  openMyParametersV2() {
    this.router.navigate([this.tenantId + '/dashboard/project/myparameter-v2']);
  }

   // getter for easy access to form fields
   get f() {
    return this.projectv2Form.controls;
  }


  getUsers() {
    this.userService.getUserDetailsList().subscribe((response: any) => {
      this.users = response;
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.projectv2Form.patchValue(this.selectedCheckboxData[0])
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.projectService.deleteProjectV2(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  updateProjectV2() {
    let currentProjectId = this.selectedCheckboxData[0].id; 
    this.router.navigate([this.tenantId + '/dashboard/project/myparameter-v2'], { queryParams: { projectID: currentProjectId } });
    if (this.projectId) {
      this.projectService.updateProjectV2(this.projectId, this.projectv2Form.value).subscribe(response => {
        this.backToMyProjectV2()
      }, error => {
        this.openSnackBar('ERROR: cannot update project: ' + error);
      })
    }
  }

  backToMyProjectV2(){
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/myproject-v2']);
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

}
